import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { LoginService, UsuarioService, CidadeService } from '../../services/';
import { Usuario } from '../../model';


@Component({
  selector: 'perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss'],
})
export class PerfilComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private usuarioService: UsuarioService,
    private cidadeService: CidadeService,
    private formBuilder: FormBuilder,) { }


    usuario: Usuario = new Usuario();

    // Area de controle de alteração de Senha
    senhaAtual: string;
    senha: string;
    resenha: string;
    mensagemSucesso = '';
    mensagensErro = [];
    alteraSenha: boolean = false;
    erroAlterarSenha: string;
    sucessoAlterarSenha: boolean = false;
    loadingAlterarSenha: boolean = false;

    public loading = false;

    alterarSenha(){
      this.alteraSenha = true;
      this.erroAlterarSenha = '';
      this.sucessoAlterarSenha = false;
      this.loadingAlterarSenha = true;
      if (this.senha != this.resenha){
        this.erroAlterarSenha = 'As senhas digitadas não conferem';
        this.loadingAlterarSenha = false;
      }else{
        this.usuarioService.alterarSenha(this.usuario.Id, this.senha, this.senhaAtual).subscribe(
          dados => {
            this.sucessoAlterarSenha = true;
            this.loadingAlterarSenha = false;
          },
          erro => {
            this.loadingAlterarSenha = false;
            if (erro.status == 400){
              this.erroAlterarSenha = erro.error.mensagem;
            }else if (erro.status = 406){
              this.erroAlterarSenha = erro.error.mensagens[0];
            }
            else{
              this.erroAlterarSenha = 'Erro ao alterar a senha, tente novamente mais tarde!';
            }
            console.log(erro);
          });
        }
        this.senha = '';
        this.resenha = '';
        this.senhaAtual = '';

      }


      data = [{id: 1, name: 'Usa' },
      {id: 2, name: 'England' }];

      selecionaCidade(item) {
        this.usuario.Cidade = item;
      }

      onChangeCidade(val: string) {
        this.cidadeService.buscarPorParametro(val, 1).subscribe(
          dados => {
            this.data = dados.Items.map(function(x){
              x.display_field = x.Nome + ' / ' + x.Estado.Nome + ' - ' + x.Estado.Pais.Nome;
              return x;
            });

          },
          erro => {
            console.log(erro);
            this.data = [];

          },
        );

      }


      salvar(){
        this.mensagemSucesso = '';
        this.mensagensErro = [];
        this.usuarioService.salvarDados(this.usuario).subscribe(
          dados => {
            this.mensagemSucesso = "Alterações salvas com sucesso";
          },
          erro => {
            this.mensagensErro = this.errorHandler(erro);
            console.log("Erro ao salvar os dados do perfil");
            console.log(erro);
          }
        );

      }



      form: FormGroup;
      emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      numberPattern = /^[0-9]*$/;

      public display = {
        CidadeId: 'Cidade'
      };

      ngOnInit() {
        // console.log("BUSCANDO DADOS");
        // this.usuario = new Usuario();
        this.usuarioService.getUserById(this.loginService.user().Id).subscribe(
          dados => {
            this.usuario = dados.Items[0];
          },
          erro => {
            console.log("Erro ao buscar os meus dados");
            console.log(erro);
          }
        );


        this.form = this.formBuilder.group({
          Nome: this.formBuilder.control('', [Validators.required, Validators.minLength(3)]),
          Email: this.formBuilder.control('', [Validators.required]),
          Telefone: this.formBuilder.control('', [Validators.required]),
          Logradouro: this.formBuilder.control('', [Validators.required]),
          Cep: this.formBuilder.control('', [Validators.required]),
          Numero: this.formBuilder.control('', [Validators.required]),
          Complemento: this.formBuilder.control('', []),
          CidadeId: this.formBuilder.control('', [Validators.required]),
        });

        this.form.markAsDirty();
        this.form.markAsTouched();
      }


      getFormValidationErrors() {
        let erros = [];
        Object.keys(this.form.controls).forEach(key => {

          const controlErrors: ValidationErrors = this.form.get(key).errors;
          if (controlErrors != null) {

            Object.keys(controlErrors).forEach(keyError => {
              const erro = { key: key, keyError: keyError, value: controlErrors[keyError] };
              erros = [...erros, erro];
            });
          }
        });
        return erros;
      }

      buscaCep(){

        this.cidadeService.buscarEnderecoPorCep(this.usuario.Cep).subscribe(
          dados => {
            
            if(dados.logradouro && dados.logradouro.length > 0)
            this.usuario.Logradouro = dados.logradouro;

            if(dados.bairro && dados.bairro.length > 0)
            this.usuario.Bairro = dados.bairro;

            if(dados.complemento && dados.complemento.length > 0)
            this.usuario.Complemento = dados.complemento;

            if(dados.ibge && dados.ibge.length > 0){
              this.cidadeService.buscaCidadePorIbge(dados.ibge).subscribe(
                cidade => {
                  if(cidade != null){
                    this.usuario.Cidade = cidade;
                  }
                }
              );
            }


          }
        )

      }


      public errorHandler(erro): string[]{

        let mensagem = [];
        ;
        switch (erro.status){
          case 0: mensagem.push('o servidor não respondeu, tente novamente mais tarde!'); break;
          case 400: 
      
        if(erro.error && erro.error.mensagem)
          mensagem.push(erro.error.mensagem);
        else
          mensagem.push("Houve algum erro na execução, tente novamente!");

      break;
          case 401: mensagem.push('você não tem autorização para executar esta ação!'); break;
          case 404: mensagem.push(erro.error.mensagem ); break;
          case 406: console.log('a requisição não foi aceita!' ); break;
          case 500: mensagem.push('Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte' ); break;
          default : mensagem.push(erro.statusText);
        }
        if (erro.error != null && erro.error.mensagens != null){
          mensagem = [...mensagem, ...erro.error.mensagens];
        }
        return mensagem;

      }

    }
